import { render, staticRenderFns } from "./NflPlayerTrends.vue?vue&type=template&id=e5e2b5d0&scoped=true"
import script from "./NflPlayerTrends.vue?vue&type=script&lang=js"
export * from "./NflPlayerTrends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e2b5d0",
  null
  
)

export default component.exports